import React from 'react';
import {
  BreakpointQueryName, Button, ButtonColor, ButtonSize,
} from '@doveit/lego';
import * as styles from './BottomBarV2.style';

export interface BottomBarProps {
  title: string,
  label: string,
  href?: string,
  onClick: VoidFunction,
  visible?: boolean,
  hiddenFrom?: BreakpointQueryName,
  dataRef?: string,
  dataTracking?: string,
}

const BottomBarV2: React.FC<BottomBarProps> = ({
  title,
  label,
  href,
  onClick,
  visible,
  hiddenFrom,
  dataRef = 'bottom-bar',
  dataTracking,
}) => (
  <div
    css={styles.main}
    $visible={visible}
    $hiddenFrom={hiddenFrom}
    data-ref={dataRef}
  >
    <div
      css={styles.title}
      data-ref={`${dataRef}-title`}
    >
      {title}
    </div>
    <Button
      label={label}
      title={label}
      onClick={onClick}
      href={href}
      size={ButtonSize.SMALL}
      color={ButtonColor.PRIMARY}
      dataRef={`${dataRef}-cta`}
      dataTracking={dataTracking}
    />
  </div>
);

export default BottomBarV2;
